import { type ApiError, toApiError } from "./client";

/**
 * openapi-fetch returns `{ data, error, response }`. TanStack Query wants a
 * promise that resolves to data or throws. This adapter throws a normalized
 * ApiError so query/mutation `onError` handlers and error boundaries get a
 * consistent shape.
 */
export async function unwrap<T>(
  promise: Promise<{
    data?: T;
    error?: unknown;
    response: Response;
  }>,
): Promise<T> {
  const { data, error, response } = await promise;
  if (error !== undefined || !response.ok) {
    throw toApiError(response.status, error);
  }
  return data as T;
}

export type { ApiError };
